module.exports = __webpack_public_path__ + "img/frame (191).e77012a0.jpg";